<template>
	<div id="header">
		<shortcut-bar style="z-index: 999;position: fixed;" />
		<div style="height: 56px;"></div>
		<search-area />
	</div>
</template>

<script>
	import ShortcutBar from '@/components/ShortcutBar'
	import SearchArea from '@/components/SearchArea'

	export default {
		name: 'AppHeader',
		components: {
			'shortcut-bar': ShortcutBar,
			'search-area': SearchArea,
		},
		data() {
			return {}
		},
	};
</script>

<style scoped>
	#header {
		width: 100%;
		min-height: 120px;
		height: auto;
		padding-bottom: 16px;
		overflow: visible;
	}
</style>


// WEBPACK FOOTER //
// src/components/AppHeader.vue